// Local Desk realtime repair.
// Frappe only targets socketio_port when window.dev_server is truthy. Some
// direct `bench serve --port ...` sessions render Desk without that flag,
// making the client poll /socket.io on the web port and fail.

function isLocalHost() {
	return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
}

function getSocketPort() {
	const bootPort = window.frappe?.boot?.socketio_port;
	const globalPort = window.socketio_port;
	return bootPort || globalPort || 9000;
}

function expectedHost(port) {
	const protocol = window.location.protocol;
	const host = window.location.hostname.includes(":")
		? `[${window.location.hostname}]`
		: window.location.hostname;
	const site = window.frappe?.boot?.sitename;
	return site ? `${protocol}//${host}:${port}/${site}` : null;
}

function repairExistingSocket(port) {
	const rt = window.frappe?.realtime;
	if (!rt) return;

	const target = expectedHost(port);
	const current = rt.socket?.io?.uri;
	if (!target || !current || current === target) return;

	try {
		rt.socket.disconnect();
		rt.socket.off();
	} catch (e) {}
	try {
		delete rt.socket;
		rt.lazy_connect = false;
		rt.init(port);
	} catch (e) {}
}

export const realtimeFix = {
	mount() {
		if (!isLocalHost()) return;

		const port = getSocketPort();
		window.socketio_port = port;
		window.dev_server = true;

		repairExistingSocket(port);

		document.addEventListener("DOMContentLoaded", () => {
			window.dev_server = true;
			repairExistingSocket(port);
		}, { once: true });

		try {
			const $ = window.jQuery || window.$;
			if ($) {
				$(document).on("startup app_ready", () => {
					window.dev_server = true;
					repairExistingSocket(port);
				});
			}
		} catch (e) {}
	},
};
